import(/* webpackMode: "eager" */ "/codebuild/output/src225004783/src/crew-express-web-frontend/packages/admin/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppRouterAppProvider"] */ "/codebuild/output/src225004783/src/crew-express-web-frontend/packages/admin/providers/app_router_app_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledComponentsRegistry"] */ "/codebuild/output/src225004783/src/crew-express-web-frontend/packages/admin/providers/registry.tsx");
